import React, { Component } from "react";

const ServiceList = [
    {
        icon: '01',
        title: 'Boost',
        description: 'Boost your small or medium-sized business with our expert online services.'
    },
    {
        icon: '02',
        title: 'Harness the power',
        description: 'Harness the power of Facebook, Google, Taboola, and TikTok with our social media expertise.'
    },
    {
        icon: '03',
        title: 'Affordable & flexible',
        description: 'Affordable and flexible pricing options designed to meet the needs of small and medium-sized businesses.'
    },
]

class ServiceOne extends Component{
    render(){
        return(
            <React.Fragment>
                <div className="row">
                    {ServiceList.map( (val , i) => (
                        <div className="col-lg-4 col-md-6 col-sm-6 col-12" key={i}>
                            <div className="service service__style--1">
                                <div className="icon">
                                    <img src={`/assets/images/icons/icon-${val.icon}.png`} alt="Digital Agency"/>
                                </div>
                                <div className="content">
                                    <h4 className="title">{val.title}</h4>
                                    <p>{val.description}</p>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>
            </React.Fragment>
        )
    }
}
export default ServiceOne;